// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + {"141":"history","474":"revew","485":"game","857":"report","884":"admin","966":"login"}[chunkId] + "." + {"141":"983c5a20","474":"e8f4601f","485":"8758bd1f","857":"4a7a375a","884":"e0e28cc9","966":"23bf0ea0"}[chunkId] + ".css";
};